var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRocketUnknown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE164"
    },
    d: "M132.412,467.862L132.412,467.862c-4.875,0-8.828-3.953-8.828-8.828V335.446 c0-4.875,3.953-8.828,8.828-8.828l0,0c4.875,0,8.828,3.953,8.828,8.828v123.588C141.24,463.909,137.287,467.862,132.412,467.862z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE164"
    },
    d: "M379.589,467.862L379.589,467.862c-4.875,0-8.828-3.953-8.828-8.828V335.446 c0-4.875,3.953-8.828,8.828-8.828l0,0c4.875,0,8.828,3.953,8.828,8.828v123.588C388.417,463.909,384.464,467.862,379.589,467.862z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE164"
    },
    d: "M344.278,370.756L344.278,370.756c-4.875,0-8.828-3.953-8.828-8.828v-97.105 c0-4.875,3.953-8.828,8.828-8.828l0,0c4.875,0,8.828,3.953,8.828,8.828v97.105C353.106,366.804,349.153,370.756,344.278,370.756z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE164"
    },
    d: "M167.723,370.756L167.723,370.756c-4.875,0-8.828-3.953-8.828-8.828v-97.105 c0-4.875,3.953-8.828,8.828-8.828l0,0c4.875,0,8.828,3.953,8.828,8.828v97.105C176.551,366.804,172.598,370.756,167.723,370.756z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF6464"
    },
    d: "M256,150.063l-125.79,100.632c-4.188,3.35-6.626,8.423-6.626,13.787v44.481L256,282.479 l132.416,26.483v-44.481c0-5.364-2.438-10.437-6.626-13.787L256,150.063z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE164"
    },
    d: "M225.103,361.906c0,29.551,3.571,93.193,24.392,145.365c2.516,6.305,10.494,6.305,13.01,0 c20.821-52.172,24.392-115.814,24.392-145.365H225.103z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M238.345,361.906c0,14.173,2.452,46.271,17.655,70.032c15.204-23.761,17.655-55.859,17.655-70.032 H238.345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#959CB3"
    },
    d: "M299.876,350.958l-10.499-41.997h-66.753l-10.499,41.997c-0.66,2.638-0.065,5.431,1.608,7.573 s4.237,3.396,6.957,3.396h70.622c2.72,0,5.285-1.255,6.957-3.396C299.942,356.389,300.535,353.596,299.876,350.958z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#707487"
    },
    d: "M238.609,350.958l10.499-41.997h-26.483l-10.499,41.997c-0.66,2.638-0.065,5.431,1.608,7.573 s4.237,3.396,6.957,3.396h26.483c-2.72,0-5.285-1.255-6.957-3.396S237.949,353.596,238.609,350.958z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4EAF6"
    },
    d: "M248.639,4.316l-41.109,73.457c-2.948,5.269-4.497,11.207-4.497,17.245v213.945 c0,9.751,7.904,17.655,17.655,17.655h70.622c9.751,0,17.655-7.904,17.655-17.655V95.013c0-6.038-1.548-11.976-4.498-17.245 L263.362,4.316C260.141-1.439,251.86-1.439,248.639,4.316z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C7CFE2"
    },
    d: "M238.345,308.962V95.018c0-6.038,0.644-11.976,1.874-17.244l17.128-73.457 c0.321-1.474,0.898-2.664,1.581-3.729c-3.669-1.35-8.118-0.15-10.289,3.729l-41.109,73.456c-2.948,5.269-4.497,11.206-4.497,17.244 v213.945c0,9.75,7.905,17.655,17.655,17.655h25.012C241.639,326.618,238.345,318.713,238.345,308.962z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF6464"
    },
    d: "M263.362,4.316c-3.22-5.753-11.501-5.753-14.721,0l-41.11,73.457 c-2.948,5.269-4.497,11.206-4.497,17.244v46.218h105.933V95.013c0-6.038-1.548-11.976-4.498-17.245L263.362,4.316z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D2555A"
    },
    d: "M238.345,95.018c0-6.038,0.644-11.976,1.874-17.244l17.128-73.457 c0.321-1.474,0.898-2.664,1.581-3.729c-1.788-0.658-3.755-0.686-5.559-0.119c-0.135,0.044-0.262,0.108-0.393,0.158 c-0.689,0.256-1.334,0.626-1.944,1.069c-0.19,0.14-0.386,0.269-0.566,0.428c-0.694,0.607-1.333,1.31-1.826,2.193l-41.109,73.456 c-2.948,5.269-4.497,11.206-4.497,17.244v46.218h35.311V95.018z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C7CFE2"
    },
    d: "M308.967,141.235H203.034v17.655h22.637c6.089,10.511,17.302,17.655,30.33,17.655 c13.028,0,24.241-7.145,30.33-17.655h22.637V141.235z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#5B5D6E"
    },
    cx: 256.005,
    cy: 141.233,
    r: 17.655
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AFB9D2"
    },
    d: "M238.345,171.716v-30.482h-35.311v17.655h22.637C228.736,164.182,233.105,168.613,238.345,171.716z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#707487"
    },
    d: "M248.64,4.316l-32.162,57.47h79.047l-32.164-57.47C260.141-1.439,251.86-1.439,248.64,4.316z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5B5D6E"
    },
    d: "M243.947,61.786l13.401-57.47c0.321-1.474,0.898-2.664,1.581-3.729 c-1.788-0.658-3.755-0.686-5.559-0.119c-0.036,0.012-0.072,0.031-0.108,0.044c-0.095,0.039-0.189,0.078-0.285,0.115 c-0.689,0.256-1.334,0.626-1.944,1.069c-0.066,0.049-0.131,0.102-0.198,0.149c-0.121,0.095-0.252,0.177-0.369,0.279 c-0.693,0.606-1.332,1.31-1.825,2.191l-32.162,57.47H243.947z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D2555A"
    },
    points: "123.584,308.962 203.034,293.072 203.034,255.996 123.584,277.182  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D2555A"
    },
    points: "388.417,308.962 308.967,293.072 308.967,255.996 388.417,277.182  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AFB9D2"
    },
    d: "M132.412,264.824L132.412,264.824c-4.875,0-8.828,3.953-8.828,8.828v70.622 c0,4.875,3.953,8.828,8.828,8.828l0,0c4.875,0,8.828-3.953,8.828-8.828v-70.622C141.24,268.776,137.287,264.824,132.412,264.824z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AFB9D2"
    },
    d: "M167.723,255.996L167.723,255.996c-4.875,0-8.828,3.953-8.828,8.828v44.139 c0,4.875,3.953,8.828,8.828,8.828l0,0c4.875,0,8.828-3.953,8.828-8.828v-44.139C176.551,259.948,172.598,255.996,167.723,255.996z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AFB9D2"
    },
    d: "M379.589,264.824L379.589,264.824c4.875,0,8.828,3.953,8.828,8.828v70.622 c0,4.875-3.953,8.828-8.828,8.828l0,0c-4.875,0-8.828-3.953-8.828-8.828v-70.622C370.761,268.776,374.714,264.824,379.589,264.824z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AFB9D2"
    },
    d: "M344.278,255.996L344.278,255.996c4.875,0,8.828,3.953,8.828,8.828v44.139 c0,4.875-3.953,8.828-8.828,8.828l0,0c-4.875,0-8.828-3.953-8.828-8.828v-44.139C335.45,259.948,339.403,255.996,344.278,255.996z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#959CB3"
    },
    cx: 132.582,
    cy: 273.484,
    r: 8.999
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#959CB3"
    },
    cx: 167.727,
    cy: 264.821,
    r: 8.999
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#959CB3"
    },
    cx: 379.417,
    cy: 273.484,
    r: 8.999
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#959CB3"
    },
    cx: 344.282,
    cy: 264.821,
    r: 8.999
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C7CFE2"
    },
    d: "M256,291.307L256,291.307c4.875,0,8.828-3.953,8.828-8.828v-35.311c0-4.875-3.953-8.828-8.828-8.828 l0,0c-4.875,0-8.828,3.953-8.828,8.828v35.311C247.173,287.354,251.125,291.307,256,291.307z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C7CFE2"
    },
    d: "M282.484,291.307L282.484,291.307c4.875,0,8.828-3.953,8.828-8.828v-35.311 c0-4.875-3.953-8.828-8.828-8.828l0,0c-4.875,0-8.828,3.953-8.828,8.828v35.311C273.656,287.354,277.609,291.307,282.484,291.307z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AFB9D2"
    },
    d: "M229.517,291.307L229.517,291.307c4.875,0,8.828-3.953,8.828-8.828v-35.311 c0-4.875-3.953-8.828-8.828-8.828l0,0c-4.875,0-8.828,3.953-8.828,8.828v35.311C220.689,287.354,224.642,291.307,229.517,291.307z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocketUnknown);
export default __webpack_public_path__ + "static/media/rocketUnknown.68840f0fcaf138e3b200abce00a5d848.svg";
export { ForwardRef as ReactComponent };